import { useCallback } from "react"

import { useLocationDialogStore } from "../store/dialog"

export function useLocationDialogs() {
  const { isOpen, setIsOpen } = useLocationDialogStore()

  const openLocationDialog = useCallback(() => {
    setIsOpen(true)
  }, [setIsOpen])

  const closeLocationDialog = useCallback(() => {
    setIsOpen(false)
  }, [setIsOpen])

  const toggleLocationDialog = useCallback(() => {
    setIsOpen(!isOpen)
  }, [isOpen, setIsOpen])

  return {
    isLocationDialogOpen: isOpen,
    openLocationDialog,
    closeLocationDialog,
    toggleLocationDialog,
  }
}
